import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "cio/pods/integrations/forms/form_details/template.hbs" })